import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

/** SUPER_ADMINS or QTAP_ADMINS — elevated UI pages. */
export default function ElevatedAdminRoute({ children }) {
  const { user } = useAuth();

  return (
    <ProtectedRoute>
      {user === null ? null : !user?.is_elevated_admin ? (
        <Navigate to="/timetable" replace />
      ) : (
        children
      )}
    </ProtectedRoute>
  );
}
